<template>
    <div class="embed-locked relative">
        <div class="absolute grid h-full w-full cursor-pointer place-items-center" @click="openDialog">
            <div class="button-play-locked">
                <div class="rounded-lg bg-red-600 bg-opacity-80 px-8 py-3 text-white hover:bg-opacity-100">
                    <IconPlay></IconPlay>
                </div>
            </div>
        </div>
        <ImageOptimized :src="poster" alt="" class="video-poster aspect-[40/21] w-full" />
        <LayoutDialog
            v-if="dialog"
        >
            <template v-slot:content>
                <p class="mb-3 text-2xl font-semibold leading-10 sm:text-3xl">
                    Get total access to <br />{{ $config.public.siteName }}
                </p>
                <p class="sm:text-lg">All videos, courses and live streams</p>
            </template>
            <template v-slot:buttons>
                <div>
                    <ButtonPrimary
                        :buttonRoute="useContextConversion().routeMembership('video-locked-embed')"
                        :buttonText="freeTrialAvailable ? 'Accept Free Trial' : 'Start Membership'"
                    ></ButtonPrimary>
                    <ButtonRegular
                        class="ml-3"
                        v-if="!isLoggedIn"
                        :buttonRoute="useContextConversion().routeLogin('video-locked-embed')"
                        buttonText="Login"
                    ></ButtonRegular>
                    <div class="mt-8">
                        <button class="font-semibold text-zinc-600 underline hover:no-underline" @click="closeDialog">
                            Maybe Later
                        </button>
                    </div>
                </div>
            </template>
        </LayoutDialog>
    </div>
</template>

<script>
import { mapState } from 'pinia';

export default {
    name: 'EmbedLocked',
    props: {
        poster: {
            required: false,
            type: String,
            default: null,
        },
    },
    data () {
        return {
            dialog: false,
        };
    },
    computed: {
        ...mapState(useStoreAuth, {
            currentUser: 'currentUser',
            isLoggedIn: 'isLoggedIn',
        }),
        freeTrialAvailable () {
            return !!this.currentUser?.eligible_for_aaa_free_trial;
        },
    },
    methods: {
        openDialog () {
            this.dialog = true;
        },
        closeDialog () {
            this.dialog = false;
        },
    },
};
</script>
